import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { GetPages } from "../services/auth/pages.services"
import parse from 'html-react-parser';
import { success, error } from "../constants/msg";
import { ToastContainer } from "react-toastify";
import Loader from '../components/loader/Loader';

const TermsAndConditionsPage = ({ noGutters, height }) => {
    const [pageData, setPageData] = useState("")
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const FetchPage = async () => {
            try {
                const res = await GetPages(1);
                setPageData(res.data.data)
                setIsLoading(false)
            }
            catch (e) {
                error(e.response.data.message)
            }
        }
        FetchPage()
    }, [])

    return (
        <>
            {
                isLoading ?
                    <div className='text-center mt-4'>
                        <Loader />
                    </div>
                    :

                    <div className="terms-and-condition mb-4">
                        <ToastContainer />
                        <Row className={!noGutters && 'mt-4'}>
                            <Col xs={12}>
                                <div className={`div-content text-start p-4 bg-white ${height && "h-100vh"}`}>
                                    <div className='border-bottom pb-4 mb-4'>
                                        <h5 className='p-0 m-0'>{pageData.title}</h5>
                                    </div>
                                    {
                                        pageData.content &&
                                        parse(pageData.content)
                                    }
                                </div>
                            </Col>
                        </Row>
                    </div>
            }
        </>
    )
}

export default TermsAndConditionsPage